import { Button, Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useMemo } from "react"
import { NavLink } from "react-router-dom"
import { useIBeaconsAtZoneQuery, useMeQuery } from "../../graphql"
import { checkForPermissions } from "../../utils"
import { Card } from "../common"
import { IBeaconsList } from "./IBeaconsList"

export type IBeaconsAtZoneProps = {
	zoneId: string
}

export const IBeaconsAtZone: React.FC<IBeaconsAtZoneProps> = ({ zoneId }) => {
	const [{ data, fetching, error }] = useIBeaconsAtZoneQuery({ variables: { zoneId } })

	const [{ data: meData }] = useMeQuery()

	const canAddIBeacon = useMemo(() => {
		return checkForPermissions(meData?.me, "ibeacons/add-ibeacon-to-zone")[0]
	}, [meData?.me])

	return (
		<Card
			title="iBeacons"
			action={
				canAddIBeacon && (
					<Button as={NavLink} to={`/zones/${zoneId}/ibeacons/add`} colorScheme="primary" size="sm">
						Add
					</Button>
				)
			}
		>
			{fetching ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading iBeacons</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.ibeaconsAtZone.length ? (
				<VStack w="full" align="stretch">
					<IBeaconsList ibeacons={data.ibeaconsAtZone} zoneId={zoneId} />
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any iBeacon.
					</Text>
				</Center>
			)}
		</Card>
	)
}
